var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-7" },
        [
          _c("h2", [_vm._v("Email Creator")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group inline-label" },
            [
              _c("label", { attrs: { for: "send-email-from" } }, [
                _vm._v("From")
              ]),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "text", id: "send-email-from", readonly: "" },
                domProps: { value: _vm.send_email.from.label }
              }),
              _vm._v(" "),
              _c(
                "b-form-checkbox",
                {
                  staticClass: "float-left",
                  attrs: { id: "email_to_user" },
                  model: {
                    value: _vm.send_email.bcc_me,
                    callback: function($$v) {
                      _vm.$set(_vm.send_email, "bcc_me", $$v)
                    },
                    expression: "send_email.bcc_me"
                  }
                },
                [_vm._v("Bcc me")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group inline-label" },
            [
              _c("label", { attrs: { for: "send-email-from" } }, [
                _vm._v("To")
              ]),
              _vm._v(" "),
              _c("multiselect", {
                attrs: {
                  "tag-placeholder": "Add this as custom email",
                  placeholder: "Search user or add an email",
                  "open-direction": "bottom",
                  label: "name",
                  "track-by": "track",
                  options: _vm.users,
                  multiple: true,
                  searchable: true,
                  loading: _vm.isLoading,
                  "internal-search": false,
                  "clear-on-select": false,
                  "close-on-select": false,
                  "options-limit": 300,
                  limit: 20,
                  "max-height": 600,
                  "show-no-results": false,
                  "hide-selected": true,
                  taggable: true
                },
                on: {
                  "search-change": _vm.getUsers,
                  input: _vm.toggleUserToFromMultiselect,
                  tag: _vm.addEmail
                },
                scopedSlots: _vm._u([
                  {
                    key: "tag",
                    fn: function(ref) {
                      var option = ref.option
                      var remove = ref.remove
                      return [
                        _c("span", { staticClass: "custom__tag" }, [
                          _c("span", [_vm._v(_vm._s(option.name))]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "custom__remove",
                              on: {
                                click: function($event) {
                                  return remove(option)
                                }
                              }
                            },
                            [
                              _c("span", { attrs: { "aria-hidden": "true" } }, [
                                _vm._v("×")
                              ])
                            ]
                          )
                        ])
                      ]
                    }
                  },
                  {
                    key: "clear",
                    fn: function(props) {
                      return [
                        _vm.send_email.to.length
                          ? _c("div", {
                              staticClass: "multiselect__clear",
                              on: {
                                mousedown: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.clearAll(props.search)
                                }
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.send_email.to,
                  callback: function($$v) {
                    _vm.$set(_vm.send_email, "to", $$v)
                  },
                  expression: "send_email.to"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group inline-label" },
            [
              _c("label", { attrs: { for: "send-email-from" } }, [
                _vm._v("Subject")
              ]),
              _vm._v(" "),
              _c("b-form-input", {
                attrs: {
                  id: _vm.getId("subject"),
                  type: "text",
                  required: true,
                  state: _vm.fieldState("subject"),
                  placeholder: "Please add a subject"
                },
                model: {
                  value: _vm.send_email.subject,
                  callback: function($$v) {
                    _vm.$set(_vm.send_email, "subject", $$v)
                  },
                  expression: "send_email.subject"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-invalid-feedback",
            { attrs: { state: _vm.fieldState("subject") } },
            [
              _vm._v(
                "\n                " + _vm._s(_vm.invalidField("subject")) + " "
              ),
              _c("br"),
              _vm._v(" "),
              _c("br")
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group inline-label" },
            [
              _c("label", { attrs: { for: "send-email-template" } }, [
                _vm._v("Template")
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.send_email.template,
                      expression: "send_email.template"
                    }
                  ],
                  attrs: { type: "text", id: "send-email-template" },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.send_email,
                          "template",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                      _vm.selectTemplate
                    ]
                  }
                },
                _vm._l(_vm.templates, function(option) {
                  return _c("option", { domProps: { value: option } }, [
                    _vm._v("Subject: " + _vm._s(option.subject))
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "b-form-checkbox",
                {
                  staticClass: "float-left",
                  attrs: { id: "save-template" },
                  model: {
                    value: _vm.send_email.save_template,
                    callback: function($$v) {
                      _vm.$set(_vm.send_email, "save_template", $$v)
                    },
                    expression: "send_email.save_template"
                  }
                },
                [_vm._v("Save template")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "el-upload",
                {
                  staticClass: "upload-attachment",
                  attrs: {
                    action: "#",
                    "auto-upload": false,
                    "on-remove": _vm.handleRemoveFile,
                    "on-change": _vm.handleAddFile,
                    multiple: "",
                    limit: 5,
                    "on-exceed": _vm.handleExceed,
                    "file-list": _vm.send_email.attachments
                  }
                },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small", type: "primary" } },
                    [_vm._v("Click to upload")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip"
                    },
                    [
                      _vm._v(
                        "Maximum 5 files, file size should be less than 50MB"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("editor", {
            attrs: {
              "api-key": _vm.TINYMCE_API_KEY,
              init: _vm.editor_settings
            },
            model: {
              value: _vm.send_email.content,
              callback: function($$v) {
                _vm.$set(_vm.send_email, "content", $$v)
              },
              expression: "send_email.content"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "buttons mt-4" }, [
            _c("div", { staticClass: "container-buttons" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-primary",
                  attrs: { disabled: _vm.isLoading },
                  on: { click: _vm.sendEmail }
                },
                [_vm._v("Send")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-primary ml-3",
                  on: { click: _vm.cancel }
                },
                [_vm._v("Cancel")]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-4" },
            [_c("messages", { attrs: { messages: _vm.messages } })],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-5" }, [
        _c("h2", [_vm._v("Search Users")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group form-inline" },
          [
            _c(
              "b-form-radio-group",
              {
                on: {
                  change: function($event) {
                    return _vm.getUsers(_vm.search_criteria.query)
                  }
                },
                model: {
                  value: _vm.search_criteria.filter_by_status,
                  callback: function($$v) {
                    _vm.$set(_vm.search_criteria, "filter_by_status", $$v)
                  },
                  expression: "search_criteria.filter_by_status"
                }
              },
              [
                _c(
                  "b-form-radio",
                  {
                    staticClass: "float-left",
                    attrs: {
                      value: "1",
                      id: "search-criteria-filter-by-active"
                    }
                  },
                  [_vm._v("Active")]
                ),
                _vm._v(" "),
                _c(
                  "b-form-radio",
                  {
                    staticClass: "float-left",
                    attrs: {
                      value: "2",
                      id: "search-criteria-filter-by-preview"
                    }
                  },
                  [_vm._v("Preview")]
                ),
                _vm._v(" "),
                _c(
                  "b-form-radio",
                  {
                    staticClass: "float-left",
                    attrs: { value: "3", id: "search-criteria-filter-by-stock" }
                  },
                  [_vm._v("Stock")]
                ),
                _vm._v(" "),
                _c(
                  "b-form-radio",
                  {
                    staticClass: "float-left",
                    attrs: { value: "all", id: "search-criteria-filter-by-all" }
                  },
                  [_vm._v("All")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-checkbox",
              {
                staticClass: "float-left",
                attrs: { id: "search-criteria-include-reps" },
                on: {
                  change: function($event) {
                    return _vm.getUsers(_vm.search_criteria.query)
                  }
                },
                model: {
                  value: _vm.send_email.include_reps,
                  callback: function($$v) {
                    _vm.$set(_vm.send_email, "include_reps", $$v)
                  },
                  expression: "send_email.include_reps"
                }
              },
              [_vm._v("Include Reps")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.search_criteria.query,
                  expression: "search_criteria.query"
                }
              ],
              staticClass: "w-100",
              attrs: {
                type: "text",
                id: "search-criteria-company",
                placeholder: "Search users"
              },
              domProps: { value: _vm.search_criteria.query },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.search_criteria, "query", $event.target.value)
                  },
                  _vm.searchUsers
                ]
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _vm.users.length
              ? _c(
                  "div",
                  { staticClass: "user-list-container" },
                  [
                    _c(
                      "div",
                      { staticClass: "select-all" },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            attrs: { id: "search-criteria-select-all" },
                            on: { change: _vm.selectAll },
                            model: {
                              value: _vm.search_criteria.select_all,
                              callback: function($$v) {
                                _vm.$set(_vm.search_criteria, "select_all", $$v)
                              },
                              expression: "search_criteria.select_all"
                            }
                          },
                          [_vm._v("All / None")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-form-checkbox-group", {
                      staticClass: "mb-3",
                      attrs: {
                        options: _vm.users,
                        "value-field": "track",
                        "text-field": "name"
                      },
                      on: { change: _vm.toggleUserTo },
                      model: {
                        value: _vm.search_criteria.selected,
                        callback: function($$v) {
                          _vm.$set(_vm.search_criteria, "selected", $$v)
                        },
                        expression: "search_criteria.selected"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5ef980a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ef980a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/EmailCreator/send-email.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c5ef980a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/EmailCreator/send-email.vue
// module chunks = 0